export default __webpack_public_path__ + "static/media/Mark-6-HUD-05.a12138a8.jpg";